export default "__VITE_ASSET__BnUVaY1___"